/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    DASHBOARD_BROADCAST_REDESIGN_PHASE2
 * Date:         2025-12-31
 * Modified By:  Cursor
 *
 * Description:
 * Header component for broadcasts list page with title and "Create Broadcast" button.
 * Button navigates to existing /broadcast create page.
 *
 * File Size Check:
 * - Estimated: ~60 lines
 * - Decision: Proceed (well within 200-line component limit)
 *
 * Related Screens / Modules:
 * - client/src/features/broadcast/pages/broadcasts-list/components/BroadcastsHeader.tsx (NEW)
 * - client/src/features/broadcast/pages/broadcasts-list/BroadcastsListPage.tsx
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import styles from "./BroadcastsHeader.module.scss";

interface BroadcastsHeaderProps {
  title?: string;
  createTo?: string;
}

const BroadcastsHeader: React.FC<BroadcastsHeaderProps> = ({
  title = "Broadcasts",
  createTo = "/broadcast/edit",
}) => {
  const navigate = useNavigate();

  return (
    <div className={styles.headerContainer}>
      <h1 className={styles.pageTitle}>{title}</h1>
      {/* [2026-02-24] BR-20: Buttons group — Set Alerts + Create Broadcast */}
      <div className={styles.buttonsContainer}>
        <Button
          className="btn-figma-1"
          onClick={() => navigate("/alerts")}
        >
          Set Alerts
        </Button>
        <Button
          variant="primary"
          onClick={() => navigate(createTo)}
          className={styles.createButton}
        >
          Create Broadcast
        </Button>
      </div>
    </div>
  );
};

export default BroadcastsHeader;
